module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('header', [_c('h2', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('em', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero, Counterterrorist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero, Top Eliminator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero vs. His Nemesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero, Homie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Takes His Driver’s Test")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero On Watch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero, Steady Hand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Gets a Physical")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero in Hot Pursuit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero’s Combat Moves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero at the Movies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero, Fashion Plate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Undercover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero vs. His Nemesis (II)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Noir")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero vs. Magneto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero, Crime Buster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero—His Utility Belt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Sings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Bends an Elbow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero vs. The Blob")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Broods on Unwanted Hair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero vs. His Nemesis (III)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Oldguy: Superhero Gained His Superpowers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero—His Origin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Gives Away Professional Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero vs. The Riddler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero, Scoutmaster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("McOldguy: Superhero")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero, Associate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Discovers His Brother")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero—His Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death Opens Up to Oldguy: Superhero")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Shuffles Down Memory Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Decides to Hang it Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Drops Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Attends the Associated Superheroes Conference")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero vs. His Nemesis (IV)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero’s Last Will and Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero, Jumper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero Posits the Afterlife")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldguy: Superhero, Dancer")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79a86765","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Contents.vue
// module id = 75
// module chunks = 0